import { api } from '@/lib/api';

export interface WhatsAppStatus {
  status: 'connecting' | 'connected' | 'disconnected';
  phoneNumber?: string;
  profileName?: string;
  profilePictureUrl?: string;
  qrCode?: string;
  qrExpiresAt?: string;
  billingStatus?: string;
  billingDueAt?: string;
  billingPaymentStatus?: string;
  billingPriceCents?: number;
  subscriptionActivatedAt?: string;
  subscriptionCancelledAt?: string;
  /** Story 53.15 — which backend the clinic is on (null = never provisioned). */
  provider?: 'zapi' | 'uazapi' | null;
  /** Story 53.15 — Z-API → UAZAPI cutover state (null = none). */
  migration?: WhatsAppMigration | null;
}

export interface WhatsAppMigration {
  status: 'pending' | 'uazapi_connected' | 'done' | 'rolled_back';
  /** Story 53.20 — manual recovery keeps a verified private snapshot. */
  recoveryMode?: 'manual';
  /** Story 53.20 — progress before the new QR is made available. */
  phase?: 'preparing' | 'snapshot_verified' | 'history_cleared' | 'awaiting_qr';
  startedAt: string;
  connectedAt: string | null;
  finishedAt: string | null;
}

export async function migrateToUazapi(): Promise<WhatsAppStatus & { alreadyUazapi?: boolean }> {
  const { data } = await api.post<WhatsAppStatus & { alreadyUazapi?: boolean }>('/whatsapp/migrate-to-uazapi');
  return data;
}

export async function rollbackWhatsAppMigration(): Promise<WhatsAppMigration> {
  const { data } = await api.post<WhatsAppMigration>('/whatsapp/migration/rollback');
  return data;
}

export async function finalizeWhatsAppMigration(): Promise<WhatsAppMigration> {
  const { data } = await api.post<WhatsAppMigration>('/whatsapp/migration/finalize');
  return data;
}

export async function connectWhatsApp(): Promise<WhatsAppStatus> {
  const { data } = await api.post<WhatsAppStatus>('/whatsapp/connect');
  return data;
}

export async function getWhatsAppStatus(): Promise<WhatsAppStatus> {
  const { data } = await api.get<WhatsAppStatus>('/whatsapp/status');
  return data;
}

/** RC-209 — WhatsApp desconectado e quantos agendamentos dos próximos 2 dias ficam sem mensagem. */
export interface WhatsAppAutomationRisk {
  disconnected: boolean;
  upcoming: number;
}

export async function getWhatsAppAutomationRisk(): Promise<WhatsAppAutomationRisk> {
  const { data } = await api.get<WhatsAppAutomationRisk>('/whatsapp/automation-risk');
  return data;
}

export async function disconnectWhatsApp(): Promise<{ message: string }> {
  const { data } = await api.delete<{ message: string }>('/whatsapp/disconnect');
  return data;
}
